module.exports = __webpack_public_path__ + "static/media/report4.8bb7cc1d.png";